import styled from '@emotion/styled'
import { fontSize } from 'stylist'

const SectionByline = styled.h2`
  text-align: center;
  ${fontSize('l')};
`

export default SectionByline



// WEBPACK FOOTER //
// ./src/routes/home/components/SectionByline.js